export default "__VITE_ASSET__xYapLDM1__"